/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type UserDrawerAccountHistory_viewer = {
    readonly id: string;
    readonly role: USER_ROLE;
    readonly " $refType": "UserDrawerAccountHistory_viewer";
};
export type UserDrawerAccountHistory_viewer$data = UserDrawerAccountHistory_viewer;
export type UserDrawerAccountHistory_viewer$key = {
    readonly " $data"?: UserDrawerAccountHistory_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UserDrawerAccountHistory_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserDrawerAccountHistory_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '48437dadd25e6c92d022013fdde5c0ce';
export default node;
